import Screen from "../enum/Screen"
import {Details} from ".."

export default function detailsToWebAddress(details: Details) {
  switch (details.screen) {
    case Screen.Deal:
      return `/info/${details.deal.urlSlug}`
    case Screen.DealSelectProducts:
      return `/info/${details.deal.urlSlug}/redeem`
    case Screen.DealPayment:
      return `/info/${details.deal.urlSlug}/pay`
    case Screen.DealRedemptionError:
      return `/info/${details.deal.urlSlug}/error/${details.checkoutId}/${details.paymentOrderId}`
    case Screen.DealSuccess:
      return `/info/${details.deal.urlSlug}/success/${details.redemptionId}`
    default:
      throw new Error("Unknown details state")
  }
}
